module.exports = __webpack_public_path__ + "img/doge.c7fd4d5d.svg";